import { Box, Divider, Typography } from "@mui/material";
import liff from "@line/liff";

import StyledButton from "default/components/StyledButton";
import AppLayout from "works/higurashi/components/AppLayout";

const CONTACT_EMAIL = "support@soulstudio.jp";

const createText = (text, bold = false) => ({ type: "text", text, bold });
const createList = (items, ordered = true) => ({ type: "list", ordered, items });

const PRIVACY_POLICY = {
  title: "プライバシーポリシー",
  lead:
    "SoulStudio株式会社（以下，「当社」といいます。）は，「SoulChat」（以下,「本サービス」といいます。）における，ユーザーの個人情報の取扱いについて，以下のとおりプライバシーポリシー（以下，「本ポリシー」といいます。）を定めます。",
  sections: [
    {
      id: "personal-information",
      title: "第1条（個人情報）",
      content: [
        createText(
          "「個人情報」とは，個人情報保護法にいう「個人情報」を指すものとし，生存する個人に関する情報であって，当該情報に含まれる氏名，生年月日，住所，電話番号，連絡先その他の記述等により特定の個人を識別できる情報及び容貌，指紋，声紋にかかるデータ，及び健康保険証の保険者番号などの当該情報単体から特定の個人を識別できる情報（個人識別情報）を指します。",
          true,
        ),
      ],
    },
    {
      id: "collection",
      title: "第2条（個人情報の収集方法）",
      content: [
        createText(
          "当社は，ユーザーが利用登録をする際に氏名，生年月日，住所，電話番号，メールアドレス，銀行口座番号，クレジットカード番号，運転免許証番号などの個人情報をお尋ねすることがあります。また，ユーザーと提携先などとの間でなされたユーザーの個人情報を含む取引記録や決済に関する情報を,当社の提携先（情報提供元，広告主，広告配信先などを含みます。以下，｢提携先｣といいます。）などから収集することがあります。",
          true,
        ),
      ],
    },
    {
      id: "purpose",
      title: "第3条（個人情報を収集・利用する目的）",
      content: [
        createText("当社が個人情報を収集・利用する目的は，以下のとおりです。", true),
        createList([
          "当社サービスの提供・運営のため",
          "ユーザーからのお問い合わせに回答するため（本人確認を行うことを含む）",
          "ユーザーが利用中のサービスの新機能，更新情報，キャンペーン等及び当社が提供する他のサービスの案内のメールを送付するため",
          "メンテナンス，重要なお知らせなど必要に応じたご連絡のため",
          "利用規約に違反したユーザーや，不正・不当な目的でサービスを利用しようとするユーザーの特定をし，ご利用をお断りするため",
          "ユーザーにご自身の登録情報の閲覧や変更，削除，ご利用状況の閲覧を行っていただくため",
          "有料サービスにおいて，ユーザーに利用料金を請求するため",
          "上記の利用目的に付随する目的",
        ]),
      ],
    },
    {
      id: "purpose-change",
      title: "第4条（利用目的の変更）",
      content: [
        createList([
          "当社は，利用目的が変更前と関連性を有すると合理的に認められる場合に限り，個人情報の利用目的を変更するものとします。",
          "利用目的の変更を行った場合には，変更後の目的について，当社所定の方法により，ユーザーに通知し，または本ウェブサイト上に公表するものとします。",
        ]),
      ],
    },
    {
      id: "third-party",
      title: "第5条（個人情報の第三者提供）",
      content: [
        createList([
          {
            text: "当社は，次に掲げる場合を除いて，あらかじめユーザーの同意を得ることなく，第三者に個人情報を提供することはありません。ただし，個人情報保護法その他の法令で認められる場合を除きます。",
            bold: true,
            children: [
              {
                text: "人の生命，身体または財産の保護のために必要がある場合であって，本人の同意を得ることが困難であるとき",
                bold: true,
              },
              {
                text: "公衆衛生の向上または児童の健全な育成の推進のために特に必要がある場合であって，本人の同意を得ることが困難であるとき",
                bold: true,
              },
              {
                text: "国の機関もしくは地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって，本人の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがあるとき",
                bold: true,
              },
              {
                text: "予め次の事項を告知あるいは公表し，かつ当社が個人情報保護委員会に届出をしたとき",
                bold: true,
                children: [
                  { text: "利用目的に第三者への提供を含むこと", bold: true },
                  { text: "第三者に提供されるデータの項目", bold: true },
                  { text: "第三者への提供の手段または方法", bold: true },
                  { text: "本人の求めに応じて個人情報の第三者への提供を停止すること", bold: true },
                  { text: "本人の求めを受け付ける方法", bold: true },
                ],
              },
            ],
          },
          {
            text: "前項の定めにかかわらず，次に掲げる場合には，当該情報の提供先は第三者に該当しないものとします。",
            bold: true,
            children: [
              {
                text: "当社が利用目的の達成に必要な範囲内において個人情報の取扱いの全部または一部を委託する場合",
                bold: true,
              },
              { text: "合併その他の事由による事業の承継に伴って個人情報が提供される場合", bold: true },
              {
                text: "個人情報を特定の者との間で共同して利用する場合であって，その旨並びに共同して利用される個人情報の項目，共同して利用する者の範囲，利用する者の利用目的および当該個人情報の管理について責任を有する者の氏名または名称について，あらかじめ本人に通知し，または本人が容易に知り得る状態に置いた場合",
                bold: true,
              },
            ],
          },
        ]),
      ],
    },
    {
      id: "disclosure",
      title: "第6条（個人情報の開示）",
      content: [
        createList([
          {
            text: "当社は，本人から個人情報の開示を求められたときは，本人に対し，遅滞なくこれを開示します。ただし，開示することにより次のいずれかに該当する場合は，その全部または一部を開示しないこともあり，開示しない決定をした場合には，その旨を遅滞なく通知します。なお，個人情報の開示に際しては，1件あたり1,000円の手数料を申し受けます。",
            bold: true,
            children: [
              { text: "本人または第三者の生命，身体，財産その他の権利利益を害するおそれがある場合", bold: true },
              { text: "当社の業務の適正な実施に著しい支障を及ぼすおそれがある場合", bold: true },
              { text: "その他法令に違反することとなる場合", bold: true },
            ],
          },
          {
            text: "前項の定めにかかわらず，履歴情報および特性情報などの個人情報以外の情報については，原則として開示いたしません。",
            bold: true,
          },
        ]),
      ],
    },
    {
      id: "correction",
      title: "第7条（個人情報の訂正および削除）",
      content: [
        createList([
          "ユーザーは，当社の保有する自己の個人情報が誤った情報である場合には，当社が定める手続きにより，当社に対して個人情報の訂正，追加または削除（以下，「訂正等」といいます。）を請求することができます。",
          "当社は，ユーザーから前項の請求を受けてその請求に応じる必要があると判断した場合には，遅滞なく，当該個人情報の訂正等を行うものとします。",
          "当社は，前項の規定に基づき訂正等を行った場合，または訂正等を行わない旨の決定をしたときは遅滞なく，これをユーザーに通知します。",
        ]),
      ],
    },
    {
      id: "suspension",
      title: "第8条（個人情報の利用停止等）",
      content: [
        createList([
          "当社は，本人から，個人情報が，利用目的の範囲を超えて取り扱われているという理由，または不正の手段により取得されたものであるという理由により，その利用の停止または消去（以下，「利用停止等」といいます。）を求められた場合には，遅滞なく必要な調査を行います。",
          "前項の調査結果に基づき，その請求に応じる必要があると判断した場合には，遅滞なく，当該個人情報の利用停止等を行います。",
          "当社は，前項の規定に基づき利用停止等を行った場合，または利用停止等を行わない旨の決定をしたときは，遅滞なく，これをユーザーに通知します。",
          "前2項にかかわらず，利用停止等に多額の費用を有する場合その他利用停止等を行うことが困難な場合であって，ユーザーの権利利益を保護するために必要なこれに代わるべき措置をとれる場合は，この代替策を講じるものとします。",
        ]),
      ],
    },
    {
      id: "changes",
      title: "第9条（プライバシーポリシーの変更）",
      content: [
        createList([
          "本ポリシーの内容は，法令その他本ポリシーに別段の定めのある事項を除いて，ユーザーに通知することなく，変更することができるものとします。",
          "当社が別途定める場合を除いて，変更後のプライバシーポリシーは，本ページに掲載したときから効力を生じるものとします。",
        ]),
      ],
    },
    {
      id: "contact",
      title: "第10条（お問い合わせ窓口）",
      content: [
        createText("本ポリシーに関するお問い合わせは，下記の窓口までお願いいたします。", true),
        createText(`Eメールアドレス：${CONTACT_EMAIL}`),
      ],
    },
  ],
};

const TERMS_OF_SERVICE = {
  title: "SoulChat 利用規約",
  lead: null,
  sections: [
    {
      id: "general",
      title: "1. 総則",
      content: [
        createText(
          "1.1 「SoulChat」（以下「本サービス」といいます）は、OpenAI社、Google社、Anthropic社が提供する各APIを活用して動作するLINE BOTであり、オリジナルキャラクターまたは権利者から許諾を得た既存キャラクターとのインタラクションを提供します。",
        ),
        createText("1.2 本サービスをご利用いただくすべての方（以下「利用者」といいます）は、本規約に同意したものとみなします。"),
      ],
    },
    {
      id: "service",
      title: "2. サービス内容",
      content: [
        createText("2.1 本サービスは以下の二つの形式から構成されます。"),
        createList(
          [
            "利用者がキャラクターと自由にやりとりを行うチャット形式",
            "作者が著作・制作したインタラクティブストーリーを体験できる形式",
          ],
          false,
        ),
        createText("2.2 本サービスの利用には、無料トライアル期間を除き、特定の課金プランの契約が必要です。"),
        createText("2.3 本サービスのキャラクターの発言内容を、医療や医薬品、法律等の専門的なアドバイスを目的として利用はしないでください。"),
        createText("2.4 キャラクターの発言や回答は、当社およびキャラクターに関する著作権者の公式見解を直接反映するものではありません。"),
        createText(
          "2.5 本サービスはエンターテインメント用途を主目的としており、利用者は本サービスを利用して得られる情報やコンテンツの正確性、完全性、有用性などを自己の責任の下で判断するものとします。",
        ),
      ],
    },
    {
      id: "payment",
      title: "3. 課金・決済",
      content: [
        createText(
          "3.1 本サービスの有料プランの料金は、決済サービス「Stripe」または「PayPay」を通じて支払うものとします。ただし、一部のプランでは、Stripeのみをご利用いただく場合があります。",
        ),
        createText("3.2 利用者は「Stripe」および「PayPay」の利用規約とプライバシーポリシーに同意するものとします。"),
        createText("3.3 料金体系、支払い方法、キャンセルポリシーその他の決済に関する詳細は、別途当社が指定するところによります。"),
        createText(
          "3.4 本サービスは性質上、原則として返金には応じておりません。ただし、システムエラーによる二重決済、購入処理の不具合など、当社がやむを得ないと判断した場合に限り、返金を行うことがあります。",
        ),
      ],
    },
    {
      id: "personal-data",
      title: "4. 個人情報の取り扱い",
      content: [
        createText("4.1 当社は利用者の個人情報を、関連法令および当社のプライバシーポリシーに従って適切に管理し、利用目的の範囲を超えて第三者に提供することはありません。"),
        createText("4.2 利用者が本サービスを利用することにより、本サービスが利用者のLINEのID等の必要な情報を取得することを許可するものとします。"),
        createText(
          "4.3 当社は、利用者が本サービスを通じて送信したテキストや画像などのデータについては、サービスの運営・改善および障害対応、問い合わせ対応などの正当な目的の範囲内でのみ活用し、適切な管理を行います。",
        ),
      ],
    },
    {
      id: "prohibited",
      title: "5. 禁止事項",
      content: [
        createText("5.1 以下の行為は、本サービスの利用規約に違反するものとします。"),
        createList(
          [
            "個人情報・機密情報の送信",
            "以下の内容に関する又はそれらの回答をキャラクターに期待するメッセージの送信",
            "他者を誹謗中傷・攻撃する内容",
            "差別、暴力、性的表現、政治・宗教に関する過度な主張など、一般的な公序良俗や法令に反する可能性がある内容",
            "違法行為を示唆または助長する内容",
            "法令または公序良俗に違反する行為",
            "本サービスの運営を妨げる行為",
            "他の利用者に迷惑をかける行為",
            "OpenAI、Google、Anthropicの利用規約に違反する行為",
            "その他、当社が不適切と判断する行為",
          ],
          false,
        ),
      ],
    },
    {
      id: "disclaimer",
      title: "6. 免責事項",
      content: [createText("6.1 本サービスは、本サービスの利用により生じた損害に対し、一切の責任を負わないものとします。")],
    },
    {
      id: "changes",
      title: "7. 本規約の変更",
      content: [
        createText(
          "7.1 本サービスは、本規約の内容を必要に応じて変更することができるものとします。変更内容は、当社が適切と判断する方法で告知した時点から効力を生じるものとし、変更後も引き続き本サービスを利用された場合、当該変更に同意したものとみなされます。",
        ),
      ],
    },
    {
      id: "law",
      title: "8. 適用法及び裁判管轄",
      content: [
        createText("8.1 本規約の解釈及び適用は日本法に準拠します。"),
        createText("8.2 本規約に起因する紛争については、初めに和解を試みます。和解が成立しない場合、東京地方裁判所を第一審の専属的合意管轄裁判所とします。"),
      ],
    },
    {
      id: "other",
      title: "9. その他",
      content: [
        createText("9.1 未成年の利用者は、法定代理人（親権者等）の同意を得たうえで本サービスを利用するものとします。未成年者が本サービスを利用した場合、法定代理人による同意があったものとみなします。"),
        createText("9.2 本サービス内のコンテンツ（キャラクターのデザイン、テキスト、画像、プログラムなど）に関する著作権およびその他の権利は、当社または各権利者に帰属します。"),
      ],
    },
  ],
};

const scrollToSection = (id) => {
  document.getElementById(id)?.scrollIntoView({
    behavior: "smooth",
    block: "start",
  });
};

const getSectionButtonLabel = (title) => {
  const parenthesizedTitle = title.match(/（(.+)）/);
  if (parenthesizedTitle) {
    return parenthesizedTitle[1];
  }

  return title.replace(/^\d+\.\s*/, "");
};

const BodyText = ({ children, bold = false, sx }) => (
  <Typography
    sx={(theme) => ({
      whiteSpace: "pre-line",
      fontFamily: theme.system.fonts.body,
      fontSize: "14px",
      fontWeight: bold ? 700 : 400,
      lineHeight: 1.9,
      color: theme.system.colors.text.secondary,
      ...sx,
    })}
  >
    {children}
  </Typography>
);

const LegalList = ({ items, ordered = true, depth = 0 }) => {
  const Component = ordered ? "ol" : "ul";

  return (
    <Box
      component={Component}
      sx={(theme) => ({
        mt: 1.5,
        mb: 0,
        pl: depth === 0 ? 3 : 2.5,
        color: theme.system.colors.text.secondary,
        fontFamily: theme.system.fonts.body,
        fontSize: "14px",
        lineHeight: 1.9,
      })}
    >
      {items.map((item, index) => {
        const value = typeof item === "string" ? { text: item } : item;
        return (
          <Box
            key={`${value.text}-${index}`}
            component="li"
            sx={{
              mb: value.children ? 1 : 0.75,
              fontWeight: value.bold ? 700 : 400,
            }}
          >
            {value.text}
            {value.children && (
              <LegalList items={value.children} ordered={ordered} depth={depth + 1} />
            )}
          </Box>
        );
      })}
    </Box>
  );
};

const ContentBlock = ({ block }) => {
  if (block.type === "list") {
    return <LegalList items={block.items} ordered={block.ordered} />;
  }

  return (
    <BodyText bold={block.bold} sx={{ mt: 1.5 }}>
      {block.text}
    </BodyText>
  );
};

const SectionPanel = ({ id, title, content }) => (
  <Box
    id={id}
    component="section"
    sx={{
      scrollMarginTop: 24,
      width: "100%",
      p: { xs: 2, sm: 3 },
      borderRadius: "8px",
      border: "1px solid rgba(255, 255, 255, 0.16)",
      backgroundColor: "rgba(0, 0, 0, 0.34)",
      boxShadow: "inset 0 0 12px rgba(195, 33, 32, 0.16)",
      boxSizing: "border-box",
    }}
  >
    <Typography
      sx={(theme) => ({
        fontFamily: theme.system.fonts.body,
        fontSize: "17px",
        fontWeight: 700,
        lineHeight: 1.7,
        color: theme.system.colors.text.primary,
      })}
    >
      {title}
    </Typography>
    <Divider sx={{ mt: 1.5, borderColor: "rgba(255, 255, 255, 0.12)" }} />
    <Box sx={{ mt: 1 }}>
      {content.map((block, index) => (
        <ContentBlock key={index} block={block} />
      ))}
    </Box>
  </Box>
);

function LegalDocument({ document }) {
  const handleCloseWindow = () => {
    liff.closeWindow();
  };

  return (
    <AppLayout page="Rules">
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "100%",
          py: 4,
        }}
      >
        <Box sx={{ textAlign: "center", mb: 4 }}>
          <Typography
            sx={(theme) => ({
              fontFamily: theme.system.fonts.brush,
              fontSize: "32px",
              lineHeight: 1.35,
              color: theme.system.colors.text.primary,
            })}
          >
            Soul
            <Box
              component="span"
              sx={(theme) => ({
                color: theme.system.colors.red,
                fontFamily: "inherit",
                fontSize: "inherit",
                lineHeight: "inherit",
              })}
            >
              C
            </Box>
            hat
          </Typography>
          <Typography
            component="h1"
            sx={(theme) => ({
              fontFamily: theme.system.fonts.brush,
              fontSize: { xs: "25px", sm: "27px" },
              lineHeight: 1.45,
              color: theme.system.colors.text.primary,
            })}
          >
            {document.title}
          </Typography>
        </Box>

        <Box
          component="main"
          sx={{
            width: "100%",
            maxWidth: 760,
            display: "flex",
            flexDirection: "column",
            gap: 3,
          }}
        >
          {document.lead && (
            <Box sx={{ px: { xs: 0.5, sm: 1 }, pb: 1 }}>
              <BodyText bold sx={{ maxWidth: 700, color: "inherit" }}>
                {document.lead}
              </BodyText>
              <Box
                sx={(theme) => ({
                  width: 44,
                  height: 2,
                  mt: 2,
                  backgroundColor: theme.system.colors.red,
                })}
              />
            </Box>
          )}

          <Box
            aria-label={`${document.title} 目次`}
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: 1,
            }}
          >
            {document.sections.map((section) => (
              <Box
                key={section.id}
                component="button"
                type="button"
                onClick={() => scrollToSection(section.id)}
                sx={(theme) => ({
                  px: 1.5,
                  py: 0.75,
                  borderRadius: "999px",
                  border: "1px solid rgba(255, 255, 255, 0.24)",
                  backgroundColor: "rgba(255, 255, 255, 0.08)",
                  color: theme.system.colors.text.primary,
                  fontFamily: theme.system.fonts.body,
                  fontSize: "12px",
                  fontWeight: 700,
                  cursor: "pointer",
                })}
              >
                {getSectionButtonLabel(section.title)}
              </Box>
            ))}
          </Box>

          {document.sections.map((section) => (
            <SectionPanel key={section.id} {...section} />
          ))}

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 2,
              pt: 2,
            }}
          >
            <StyledButton variant="contained" onClick={handleCloseWindow}>
              チャットに戻る
            </StyledButton>
          </Box>
        </Box>
      </Box>
    </AppLayout>
  );
}

export function TermsOfService() {
  return <LegalDocument document={TERMS_OF_SERVICE} />;
}

export function PrivacyPolicy() {
  return <LegalDocument document={PRIVACY_POLICY} />;
}

export default LegalDocument;
